var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.433133 4.70224C0.655822 4.47962 0.957813 4.35456 1.2727 4.35456C1.58758 4.35456 1.88957 4.47962 2.11226 4.70224L6.31126 8.90124L14.7069 0.504428C14.8171 0.394097 14.948 0.306563 15.0921 0.246822C15.2362 0.187082 15.3906 0.156305 15.5466 0.15625C15.7026 0.156195 15.8571 0.186862 16.0012 0.246501C16.1453 0.306139 16.2763 0.393582 16.3866 0.503834C16.4969 0.614087 16.5845 0.744992 16.6442 0.889074C16.7039 1.03316 16.7347 1.18759 16.7348 1.34357C16.7348 1.49955 16.7042 1.65401 16.6445 1.79813C16.5849 1.94226 16.4974 2.07322 16.3872 2.18355L6.31126 12.2595L0.433133 6.38137C0.210511 6.15868 0.0854492 5.85669 0.0854492 5.5418C0.0854492 5.22692 0.210511 4.92493 0.433133 4.70224Z",
    fill: "#4A86F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickMark);
export default __webpack_public_path__ + "static/media/tickMark.0de0618d77b32c1b9d824fa2f462409a.svg";
export { ForwardRef as ReactComponent };